import { useState, useCallback } from 'react';

export function useCSVExport() {
  const [exportingData, setExportingData] = useState(false);

  const downloadCSV = useCallback((csvContent: string, filename: string) => {
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, []);

  return {
    exportingData,
    setExportingData,
    downloadCSV,
  };
}
